<template>
    <div>
        
        <PreventiveSleepApnea />
    </div>
</template>

<script>

import PreventiveSleepApnea from '../blog-details/PreventiveSleepApnea.vue'

export default {
    components: {
      
        PreventiveSleepApnea,
    }
}
</script>